import { IFieldHandler } from "./IFieldHandler";
import { XRFieldTypeAnnotatedParamJson } from "../ItemConfiguration";
import { IFromToSelection } from "../../UI/Controls/itemSelectionFromTo";
import { IAnyMap, IReference } from "../../../globals";

export class ItemSelectionFieldHandlerFromTo implements IFieldHandler {
    protected config: XRFieldTypeAnnotatedParamJson;
    private fieldType: string;

    private selectedItems: IFromToSelection;
    private defaultSelection: IReference[] = [];

    constructor(configIn: XRFieldTypeAnnotatedParamJson, fieldTypeIn?: string) {
        this.config = configIn;
        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
        this.fieldType = fieldTypeIn;
        // initialize object
        this.selectedItems = { from: [], to: [] };
    }

    getData(): string | undefined {
        return JSON.stringify(this.selectedItems);
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    setData(value: string, doValidation?: boolean) {
        this.selectedItems = JSON.parse(value);
    }

    getFieldType(): string {
        return this.fieldType;
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    initData(serializedFieldData: string | undefined) {
        this.selectedItems = { from: [], to: [] };
        if (serializedFieldData && serializedFieldData !== "undefined" && serializedFieldData !== "") {
            this.selectedItems = JSON.parse(serializedFieldData);
        } else if (this.config && this.config.parameter && this.config.parameter.allTo) {
            this.selectedItems.to = this.defaultSelection;
        }
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    getSelectedItems() {
        return this.selectedItems;
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    setSelectedItems(data: IFromToSelection) {
        this.selectedItems = data;
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    setFromSelectiont(newSelection: IReference[]) {
        this.selectedItems.from = newSelection;
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    setToSelectiont(newSelection: IReference[]) {
        this.selectedItems.to = newSelection;
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    isDefaultSelection() {
        if (this.defaultSelection.length !== this.selectedItems.to.length) {
            return false;
        }
        const notInDefault = this.selectedItems.to.filter((d: IReference) => {
            return this.defaultSelection.reduce((prev, item) => {
                if (item.to === d.to) {
                    return false;
                } else {
                    return prev;
                }
            }, true);
        });
        return notInDefault.length === 0;
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    setDefaultSelection(map: IReference[]) {
        this.defaultSelection = map;
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    setConfig(config: IAnyMap) {
        this.config = config;
    }
}
